import Button from "components/Button";
import { Component } from "react";
import { withTranslation } from "react-i18next";
import { isChunkLoadError } from "./version";

const RELOADED_AT_KEY = "chunkErrorReloadedAt";
// A chunk that is still missing right after a reload is a real outage, not a
// stale tab; showing the error then avoids a reload loop.
const RELOAD_COOLDOWN_MS = 30 * 1000;

const reloadedRecently = () =>
  Date.now() - Number(sessionStorage.getItem(RELOADED_AT_KEY) || 0) <
  RELOAD_COOLDOWN_MS;

class ChunkErrorBoundary extends Component {
  state = { error: null };

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error) {
    if (isChunkLoadError(error) && !reloadedRecently()) {
      sessionStorage.setItem(RELOADED_AT_KEY, String(Date.now()));
      window.location.reload();
    }
  }

  render() {
    const { error } = this.state;
    const { t, children } = this.props;
    if (!error) return children;

    return (
      <div className="flex min-h-screen items-center justify-center p-6">
        <div className="max-w-md space-y-4 rounded-2xl border border-slate-200 bg-white p-6 text-center">
          <p className="text-base font-semibold text-slate-800">{t("appUpdate.crashTitle")}</p>
          <p className="text-sm text-slate-500">{t("appUpdate.crashDescription")}</p>
          <Button.Primary className="whitespace-nowrap" onClick={() => window.location.reload()}>
            {t("appUpdate.reload")}
          </Button.Primary>
        </div>
      </div>
    );
  }
}

export default withTranslation()(ChunkErrorBoundary);
